// extracted by mini-css-extract-plugin
export var changeIcon = "_3p-4";
export var container = "_3p-0";
export var divider = "_3p-7";
export var externalLinkIcon = "_3p-1";
export var green = "_3p-5";
export var helpCircleIcon = "_3p-3";
export var iconButton = "_3p-2";
export var red = "_3p-6";